export const NEXT_STEP = 'NEXT_STEP' as const;
export const PREV_STEP = 'PREV_STEP' as const;
export const UPDATE_STEP = 'UPDATE_STEP' as const;
